import React, {Component} from "react";
import Dropzone from "react-dropzone";
import md5 from "react-native-md5";
import {Button, Checkbox, Input, Tooltip} from "antd";
import {urlPath} from "./Settings";
import {library} from "@fortawesome/fontawesome-svg-core";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckCircle, faPalette, faPaperclip, faTimesCircle, faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import {getAuthHeader, handleErrors} from "../utils/security";

library.add(faPaperclip);
library.add(faTrashAlt);
library.add(faPalette);
library.add(faTimesCircle);
library.add(faCheckCircle);

const {TextArea} = Input;
const ButtonGroup = Button.Group;
let today = null;

/*eslint eqeqeq: "off"*/
/*eslint no-array-constructor: "off"*/

/*eslint no-use-before-define: "off"*/
class AnnotationForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			annotationsDeleted: [],
			color: "0xf1c40f",
			colorPickerVisible: false,
			left: "0",
			top: "0",
			translations: {},
			valid: true,
			visible: false,
			zoom: this.props.zoom
		};
	}

	componentWillReceiveProps() {
		if (this.state.visible) {
			return;
		}
		const comp = this;
		setTimeout(function() {
			comp.setState({
				admaterial: comp.props.admaterial,
				annotationId: comp.props.annotationId,
				assetVisualId: comp.props.assetVisualId,
				annotationText: "",
				color: comp.props.color,
				closeButtonDisabled: comp.props.closeButtonDisabled,
				left: comp.props.left,
				positionX: comp.props.positionX,
				positionY: comp.props.positionY,
				annotationWidth: comp.props.annotationWidth,
				annotationHeight: comp.props.annotationHeight,
				reviewed: comp.props.reviewed,
				creator: comp.props.creator,
				time: comp.props.time,
				text: comp.props.text,
				top: comp.props.top,
				type: comp.props.type,
				translations: comp.props.translations,
				visible: comp.state.visible? comp.state.visible: comp.props.visible,
				matspec: comp.props.matspec,
				currentUser: comp.props.matspec.user.name,
				zoom: comp.props.zoom
			});
		}, 100);
		if (!this.state.visible) {
			document.getElementById("annotationFormInput").value = "";
		}

		var objToday = new Date(),
			//weekday = new Array('Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'),
			//dayOfWeek = weekday[objToday.getDay()],
			domEnder = (function() {
				var a = objToday;
				if (/1/.test(parseInt((a + "").charAt(0), 10))) return "th";
				a = parseInt((a + "").charAt(1), 10);
				return 1 == a? "st": 2 == a? "nd": 3 == a? "rd": "th";
			})(),
			dayOfMonth =
				today + (objToday.getDate() < 10)
					? objToday.getDate() + domEnder
					: objToday.getDate() + domEnder,
			months = new Array("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"),
			curMonth = months[objToday.getMonth()],
			curYear = objToday.getFullYear(),
			curHour =
				objToday.getHours() > 12
					? objToday.getHours() - 12
					: objToday.getHours() < 10
					? "0" + objToday.getHours()
					: objToday.getHours(),
			curMinute =
				objToday.getMinutes() < 10
					? "0" + objToday.getMinutes()
					: objToday.getMinutes(),
			//curSeconds = objToday.getSeconds() < 10 ? "0" + objToday.getSeconds() : objToday.getSeconds(),
			//curMeridiem = objToday.getHours() > 12 ? "PM" : "AM";
			today = curHour + ":" + curMinute + " " + dayOfMonth + " " + curMonth + ",  " + curYear;
	}

	getAnnotationValue(annotationFormInput) {
		let annotationText = document.getElementById(annotationFormInput).value;
		let annotationTextFormatted = annotationText.replace(/\n/g, "\\n");
		console.log("annotationTextFormatted", annotationTextFormatted);
		this.setState({text: annotationText, annotationTextFormatted});
		if (this.timeout) clearTimeout(this.timeout);
		this.timeout = setTimeout(() => {
			console.log("Annotation text: " + annotationText);
			this.setState({
				annotationText: annotationText,
				valid: true,
				text: annotationText
			});
			this.handleSaveAnnotation(true);
		}, 300);
	}

	saveAnnotations = (admaterial, text, type, color, x, y, w, h, annotationId, assetVisualId) => {
		const newAnnotation = {
			assetVisualId: assetVisualId,
			admaterial: admaterial,
			text: text,
			type: type,
			color: color,
			x: x,
			y: y,
			w: w,
			h: h,
			id: annotationId
		};
		if (!admaterial) delete newAnnotation.admaterial;
		if (!assetVisualId) delete newAnnotation.assetVisualId;
		this.props.saveAnnotations(newAnnotation);
		console.log("Saving annotation for AdMaterial." + admaterial);
	};

	handleSaveAnnotation = visible => {
		const {annotationText, annotationId, admaterial, type, color, positionX, positionY, assetVisualId, annotationTextFormatted, annotationWidth, annotationHeight} = this.state;
		if (annotationText.length < 1 &&
			!document
				.getElementById("annotationPost." + annotationId)
				.getAttribute("data-text")
		) {
			console.log("empty note");
			this.setState({valid: false, visible});
			//this.props.newAnnotationFlag(true);
			return null;
		}
		if (visible === false) {
			if (type === "STICKER") document.getElementById("sticker-button").click();
			if (type === "FRAME") document.getElementById("frame-button").click();
			if (type === "MARKER") document.getElementById("marker-button").click();
		}
		const annotationSignalText = document
			.getElementById("annotationPost." + annotationId)
			.getAttribute("data-text");
		console.log("Saving annotation: " + annotationText, type, color, admaterial, annotationId, assetVisualId);
		if (annotationId.includes("-")) {
			if (annotationText && annotationText.length > 0) {
				/*if (annotationId.includes('-'))
							this.saveAnnotations(admaterial, annotationText, type, color, positionX, positionY, '10', '10');
						else*/
				this.saveAnnotations(admaterial, annotationTextFormatted, type, color, positionX, positionY, annotationWidth, annotationHeight, annotationId, assetVisualId);
				this.setState({visible});
				//this.props.newAnnotationFlag(true);
			} else if (annotationSignalText && annotationSignalText.length > 0) {
				this.saveAnnotations(admaterial, annotationSignalText, type, color, positionX, positionY, annotationWidth, annotationHeight, annotationId, assetVisualId);
				this.setState({visible});
				//this.props.newAnnotationFlag(true);
			} else {
				console.error("empty annotation");
				//this.setState({valid: false , visible: true})
				//this.props.newAnnotationFlag(true);
			}
		} else {
			this.updateAnnotation();
			this.setState({visible});
		}
		if (document.getElementById("widget." + this.state.annotationId))
			document.getElementById("widget." + this.state.annotationId)
				.classList.remove("widget-highlighted");
		const approveOnly = document.getElementById("ad-approve-only");
		const approveWithChanges = document.getElementById("ad-approve-changes");
		const submit = document.getElementById("ad-submit");
		const submitOnly = document.getElementById("ad-submit-only");

		if (approveOnly) approveOnly.setAttribute("disabled", "disabled");
		if (approveWithChanges) {
			approveWithChanges.removeAttribute("disabled");
			approveWithChanges.classList.remove("d-none");
		}
		if (submit) {
			submit.removeAttribute("disabled");
			submit.classList.remove("d-none");
		}
		if (submitOnly) {
			submitOnly.removeAttribute("disabled");
			submitOnly.classList.remove("d-none");
		}
		if (document.getElementById("dummyFrame"))
			document.getElementById("dummyFrame").removeAttribute("style");
		if (document.getElementById("dummyFrameContainer"))
			document.getElementById("dummyFrameContainer").style.display = "none";
	};

	assetUpload(files) {
		console.log("Uploading asset...");
		if (document.getElementById("ad-submit"))
			document.getElementById("ad-submit").setAttribute("disabled", "disabled");
		if (document.getElementById("ad-submit-only"))
			document.getElementById("ad-submit-only").setAttribute("disabled", "disabled");
		if (document.getElementById("ad-approve-changes"))
			document.getElementById("ad-approve-changes").setAttribute("disabled", "disabled");
		if (document.getElementById("ad-approve-only"))
			document.getElementById("ad-approve-only").setAttribute("disabled", "disabled");
		if (document.getElementById("progressAssetBar"))
			document.getElementById("progressAssetBar").classList.add("visible");
		if (document.getElementById("annotationFormInput"))
			document.getElementById("annotationFormInput").setAttribute("disabled", "disabled");

		files.forEach(file => {
			const reader = new FileReader();
			reader.onload = () => {
				let hex_md5 = md5.hex_md5(reader.result);
				fetch(urlPath + "/api/exists?name=" + file.name + "&md5=" + hex_md5 + "&size=" + file.size,
					{method: "GET", credentials: "include", headers: getAuthHeader()})
					.then(handleErrors)
					.then(response => response.text())
					.then(response => {
						let exists = response != "";
						console.log("Asset exists? ", exists);
						let matspecId = this.props.matspec.currentMaterialSpecification;
						console.log("matspec:", matspecId);
						if (typeof matspecId !== "undefined") {
							var formData = new FormData();
							formData.append("matspec", matspecId);
							formData.append("file", file);
							fetch(urlPath + "/api/assetsave", {method: "POST", body: formData, credentials: "include", headers: getAuthHeader()})
								.then(handleErrors)
								.then(response => response.text())
								.then(response => {
									console.log("Asset saved ", response);
									console.log(document.getElementById("annotationFormInput").value);
									this.setState({annotationTextFormatted: document.getElementById("annotationFormInput").value + "\\n" + file.name});
									document.getElementById("annotationFormInput").value =
										document.getElementById("annotationFormInput").value + "\n" + file.name + " ";
									let str = document.getElementById("annotationFormInput").value;
									str.replace(/\r\n|\r|\n/g, "&#13;&#10;");
									document.getElementById("annotationFormInput").value = str;
									if (document.getElementById("ad-submit"))
										document.getElementById("ad-submit").removeAttribute("disabled");
									if (document.getElementById("ad-submit-only"))
										document.getElementById("ad-submit-only").removeAttribute("disabled");
									if (document.getElementById("ad-approve-changes"))
										document.getElementById("ad-approve-changes").removeAttribute("disabled");
									if (document.getElementById("ad-approve-only"))
										document.getElementById("ad-approve-only").removeAttribute("disabled");
									if (document.getElementById("progressAssetBar"))
										document.getElementById("progressAssetBar").classList.remove("visible");
									if (document.getElementById("annotationFormInput"))
										document.getElementById("annotationFormInput").removeAttribute("disabled");
									//this.handleSaveAnnotation();
									//this.props.newAssetNote(response)
									this.getAnnotationValue("annotationFormInput");
									document.getElementById("refreshAssets").click();
								})
								.catch(e => console.error("Cannot save asset!", e));
						}
					})
					.catch(e => console.error("Cannot check if file exists!", e));
			};
			reader.onabort = () => console.error("File reading was aborted");
			reader.onerror = () => console.error("File reading has failed");
			reader.readAsBinaryString(file);
		});
	}

	deleteAnnotation = (admaterial, annotationId) => {
		console.log("Deleting Annotation." + annotationId + " for AdMaterial." + admaterial);
		fetch(urlPath + "/api/annotationdelete?admaterial=" + admaterial + "&id=" + annotationId,
			{method: "DELETE", credentials: "include", headers: getAuthHeader()})
			.then(response => console.log("Deleted annotation", response.text()))
			.catch(e => console.error("Cannot delete annotation", e));
	};

	handleDeleteAnnotation = () => {
		const {annotationId, type} = this.state;
		if (type === "STICKER") document.getElementById("sticker-button").click();
		if (type === "FRAME") document.getElementById("frame-button").click();
		if (type === "MARKER") document.getElementById("marker-button").click();
		const signal = document.getElementById("annotationPost." + annotationId);
		signal.style.display = "none";
		if (!annotationId.includes("-"))
			this.deleteAnnotation(this.state.admaterial, annotationId);
		if (document.getElementById("widget." + annotationId)) {
			document.getElementById("widget." + annotationId)
				.classList.remove("widget-highlighted");
			document.getElementById("widget." + annotationId).style.display = "none";
		}
		this.props.annotationDeleted(annotationId);
		/*setTimeout(function(){
				comp.setState({visible: false});
				if(annotationPosts.length < 1){
					if(document.getElementById('ad-approve-only'))
						document.getElementById('ad-approve-only').removeAttribute('disabled');
					if(document.getElementById('ad-approve-changes'))
						document.getElementById('ad-approve-changes').classList.add('d-none');
					if(document.getElementById('ad-submit-only'))
						document.getElementById('ad-submit-only').classList.add('d-none');
					if(document.getElementById('ad-submit'))
						document.getElementById('ad-submit').classList.add('d-none');
				}
			} , 250)*/
		this.props.saveAnnotations(null, annotationId);
		//const signals = document.getElementsByClassName('annotation.' + annotationId);
		//for(let i=0 ; i < signals.length ; i++) signals[i].style.display = 'none';
		const annotationPosts = document.getElementsByClassName("annotation-post");
		if (document.getElementById("dummyFrame"))
			document.getElementById("dummyFrame").removeAttribute("style");
		if (document.getElementById("dummyFrameContainer"))
			document.getElementById("dummyFrameContainer").style.display = "none";
		if (this.props.newAnnotations.length === 0) {
			const approveOnly = document.getElementById("ad-approve-only");
			if (approveOnly) approveOnly.removeAttribute('disabled')
		}

		this.handleClose();
	};

	handleClose = () => {
		this.setState({visible: false});
		if (document.getElementById("widget." + this.state.annotationId))
			document.getElementById("widget." + this.state.annotationId)
				.classList.remove("widget-highlighted");
	};

	toggleColorPicker = () => {
		const annotationColorPicker = document.getElementById("annotationColorPicker");
		if (annotationColorPicker.classList.contains("visible"))
			annotationColorPicker.classList.remove("visible");
		else annotationColorPicker.classList.add("visible");
	};

	handleColorPicker = color => {
		const {annotationId} = this.state;
		this.setState({color: "0x" + color});
		document.getElementById("annotationPost." + annotationId).style.background = "#" + color;
		this.toggleColorPicker();
	};

	handleReview(e) {
		const checked = e.target.checked;
		const comp = this;
		console.log("checked: " + checked);
		this.setState({reviewed: checked});
		setTimeout(function() {
			comp.updateAnnotation();
		}, 100);
	}

	updateAnnotation = () => {
		const {text, annotationId, admaterial, color, positionX, positionY, reviewed, assetVisualId} = this.state;
		const textFormatted = text.replace(/\n/g, "%0A");
		//const annotationSignalText = document.getElementById('annotationPost.' + annotationId).getAttribute('data-text');
		let url = admaterial < 0 && assetVisualId?
			urlPath + "/api/annotationsaveasset?asset=" + assetVisualId
			+ "&x=" + positionX + "&y=" + positionY + "&w=10&h=10&color=" + color + "&text=" + encodeURIComponent(textFormatted).replace("%250A", "%0A") + "&reviewed=" + reviewed:
			urlPath + "/api/annotationsave?admaterial=" + admaterial
			+ "&x=" + positionX + "&y=" + positionY + "&w=10&h=10&color=" + color + "&text=" + encodeURIComponent(textFormatted).replace("%250A", "%0A") + "&reviewed=" + reviewed;
		if (annotationId) url += "&id=" + annotationId;
		if (annotationId) {
			fetch(url, {method: "POST", credentials: "include", headers: getAuthHeader()})
				.then(response => console.log("Submitted note", response.text()))
				.catch(e => console.error("Cannot submit note", e));
		}
		setTimeout(function() {
			document.getElementById("annotationPost." + annotationId)
				.setAttribute("data-text", text);
			if (document.getElementById("annotationWidgetNote." + annotationId)) {
				document.getElementById("annotationWidgetNote." + annotationId).innerHTML = text;
			}
		}, 500);
	};

	render() {
		const {colorPickerVisible, reviewed, text} = this.state;
		return (
			<div
				style={{
					top: this.state.top * this.state.zoom + 15 + "px",
					left: this.state.left * this.state.zoom + 15 + "px"
				}}
				id="annotationForm"
				className="annotation-form"
				data-visible={this.state.visible}
				data-id={this.state.annotationId}
			>
				<header>
          <span className="annotation-user">
            {this.state.creator? this.state.creator: this.state.currentUser}{" "}
          </span>
					<span className="annotation-time">
            {this.state.time? this.state.time: today}
          </span>
				</header>
				<div className={this.state.valid? "annotation-form-input valid": "annotation-form-input invalid"}>
					<div data-translationkey="uploadingFiles" id="progressAssetBar">
						{this.state.translations.uploadingFiles}
					</div>
					<TextArea
						value={text && text.replace(/\\n/g, "\n")}
						id="annotationFormInput"
						rows={4}
						onChange={() => this.getAnnotationValue("annotationFormInput")}
						data-text={this.state.annotationTextFormatted}
					/>
					<div id="annotationTextField" contentEditable="true"/>
				</div>
				<footer>
					<input id="fileInput" type="file" className="d-none"/>
					<div className="d-none review-checkbox">
						<Checkbox
							defaultChecked={reviewed == "true"? true: false}
							onChange={e => this.handleReview(e)}
						>
							{this.state.translations? this.state.translations.reviewed: "Reviewed"}
						</Checkbox>
					</div>
					<ButtonGroup size="small" className="annotation-form-buttons">
						<Tooltip
							mouseEnterDelay={0.5}
							title={this.props.translations.delete}
						>
							<Button
								id="deleteAnnotationButton"
								data-translationkey="delete"
								type="danger"
								style={{color: "inherit"}}
								onClick={() => this.handleDeleteAnnotation()}
							>
								<FontAwesomeIcon icon="trash-alt"/>
							</Button>
						</Tooltip>
						<Tooltip
							mouseEnterDelay={0.5}
							title={this.props.translations.color}
						>
							<Button
								id="colorAnnotationButton"
								data-translationkey="color"
								type="default"
								onClick={() => this.toggleColorPicker()}
							>
								<FontAwesomeIcon icon="palette"/>
							</Button>
						</Tooltip>
						<Tooltip
							mouseEnterDelay={0.5}
							title={this.props.translations.assetUpload || "Upload"}
						>
							<Dropzone
								id="assetNoteDropzone"
								data-translationkey="uploadAsset"
								className="ix-creative-dropzone ix-asset-upload"
								onDrop={this.assetUpload.bind(this)}
							>
								<FontAwesomeIcon icon="paperclip"/>
							</Dropzone>
						</Tooltip>
						<Tooltip
							mouseEnterDelay={0.5}
							title={this.props.translations.close}
						>
							<Button
								id="closeAnnotation"
								type="default"
								data-translationkey="close"
								disabled={this.state.closeButtonDisabled}
								onClick={() => this.handleClose()}
							>
								<FontAwesomeIcon icon="times-circle"/>
							</Button>
						</Tooltip>
						<Tooltip mouseEnterDelay={0.5} title={this.props.translations.save}>
							<Button
								id="saveAnnotationButton"
								data-translationkey="save"
								type="default"
								onClick={() => this.handleSaveAnnotation(false)}
							>
								<FontAwesomeIcon icon="check-circle"/>
							</Button>
						</Tooltip>
					</ButtonGroup>
					<ul id="annotationColorPicker"
					    className={colorPickerVisible? "visible": ""}
					>
						<li data-color="default"
						    onClick={() => this.handleColorPicker("f1c40f")}
						/>
						<li data-color="black"
						    onClick={() => this.handleColorPicker("000000")}
						/>
						<li data-color="white"
						    onClick={() => this.handleColorPicker("ffffff")}
						/>
						<li data-color="blue"
						    onClick={() => this.handleColorPicker("2980b9")}
						/>
						<li data-color="green"
						    onClick={() => this.handleColorPicker("27ae60")}
						/>
						<li data-color="red"
						    onClick={() => this.handleColorPicker("c0392b")}
						/>
					</ul>
				</footer>
			</div>
		);
	}
}

export default AnnotationForm;



// WEBPACK FOOTER //
// ./src/components/AnnotationForm.js